// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__axy_9","buttons":"SendReceipts_buttons__2xvJr","email":"SendReceipts_email__7bMQi","bookApptTitle":"SendReceipts_bookApptTitle__2c1Nj"};